import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import Checkbox from "@material-ui/core/Checkbox";
import Popover from "@material-ui/core/Popover";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";
import DeleteIcon from "@material-ui/icons/Delete";
import validator from "validator";
import { v4 as uuidv4 } from "uuid";
// Custom Component
import Legend from "../../../Legend/Legend";
import RFIRecipientChip from "../../../Chip/RFIRecipientChip";

// Material-UI Icon
import AddIcon from "@material-ui/icons/Add";

// Custom Style
// Custom Style
import {
  oceanBlueColor,
  grayColor,
  redColor,
} from "../../../../styles/jss/cmsMainStyle";
import { rfiDetailFormStyle } from "../../../../styles/jss/components/RFI/rfiDetailFormStyle";
import { TrainRounded } from "@material-ui/icons";

// Custom Style (Typography)
const PopoverMemberNameTypography = withStyles({
  root: {
    fontSize: 15,
    fontWeight: 400,
    color: oceanBlueColor[10],
  },
})(Typography);

const PopoverCompanyNameTypography = withStyles({
  root: {
    fontSize: 12,
    fontWeight: 400,
    color: grayColor[5],
  },
})(Typography);

const PopoverInternalMsgTypography = withStyles({
  root: {
    fontSize: 10,
    fontWeight: 400,
    color: redColor[5],
  },
})(Typography);

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));

const RFIAssignList = (props) => {
  const classes = useStyles();
  const store = require("store");
  const dispatch = useDispatch();
  const userCategoryCode = store.get("user_category_code") || "";
  const isSubCon =
    userCategoryCode === "SUPPLIER" || userCategoryCode === "SUBCON";

  const submissionRFIDetailRedux = useSelector(
    (state) => state.submissionRFIDetailRedux
  );
  const {
    submissionValue,
    setSubmissionValue,
    removeRecipientAction,
    handleRecipientClipClick,
    openPopoverId,
    anchorEl,
    handleRecipientClipClose,
    selectRcptDialogHandleOpen,
    validationErrors,
    isNew,
    editable,
    transferRcptDialogOpen,
    buildRFIOpen,
    emailErrors,
    setEmailErrors,
  } = props;

  let recipientTemplate = null;
  if (
    isSubCon ||
    (!isSubCon && !isNew && submissionValue.is_draft === "Y" && !buildRFIOpen)
  ) {
    recipientTemplate = [
      {
        id: "to",
        title: "Add To",
        label: "To",
        recipientType: "TO",
        dialogOpenName: "To",
        required: true,
        show: true,
        showInRead: true,
      },
    ];
  } else if (!isSubCon || buildRFIOpen) {
    recipientTemplate = [
      {
        id: "responsible",
        title: "Add Responsible By",
        label: "Responsible By",
        recipientType: "RESPONSIBLE",
        dialogOpenName: "Responsible",
        required: true,
        show: true,
        showInRead: true,
      },
      {
        id: "approve",
        title: "Add First Approver",
        label: "First Approver",
        recipientType: "APPROVE",
        dialogOpenName: "First Approver",
        required: true,
        show: true,
        showInRead: true,
      },
      {
        id: "secondapprove",
        title: "Add Second Approver",
        label: "Second Approver",
        recipientType: "SECONDAPPROVER",
        dialogOpenName: "Second Approver",
        required: false,
        show: submissionValue.recipients.APPROVE.length > 0 ? true : false,
        showInRead:
          submissionValue.recipients.SECONDAPPROVER.length > 0 ? true : false,
      },
      {
        id: "thirdapprove",
        title: "Add Third Approver",
        label: "Third Approver",
        recipientType: "THIRDAPPROVER",
        dialogOpenName: "Third Approver",
        required: false,
        show:
          submissionValue.recipients.SECONDAPPROVER.length > 0 &&
          submissionValue.recipients.APPROVE.length > 0
            ? true
            : false,
        showInRead:
          submissionValue.recipients.THIRDAPPROVER.length > 0 ? true : false,
      },
      {
        id: "counsultant",
        title: "Add Consultant",
        label: "To Consultant",
        recipientType: "CONSULTANT",
        dialogOpenName: "Consultant",
        required: true,
        show: true,
        showInRead: true,
      },
      {
        id: "architect",
        title: "Add Architect",
        label: "To Architect",
        recipientType: "ARCHITECT",
        dialogOpenName: "Architect",
        required: false,
        show: true,
        showInRead: true,
      },
      {
        id: "pm",
        title: "Add PM /PD",
        label: "PM",
        recipientType: "PM",
        dialogOpenName: "PM",
        required: true,
        show: true,
        showInRead: true,
      },
      {
        id: "cc",
        title: "Add CC",
        label: "CC",
        recipientType: "CC",
        dialogOpenName: "CC",
        required: false,
        show: true,
        showInRead: true,
      },
    ];
  }

  const deleteConfirmAction = (type, id) => {
    let data = { ...submissionValue };
    let index = data["email"][type].findIndex((obj) => obj.id === id);
    data["email"][type][index]["status"] = "N";
    setSubmissionValue({ ...submissionValue, ...data });
  };
  const checkValidMail = async (type, name, id) => {
    let data = { ...emailErrors };
    if (!validator.isEmail(name)) {
      if (data[type].findIndex((obj) => obj === id) === -1) {
        let emailValidator = id;
        data[type].push(emailValidator);
        setEmailErrors({ ...emailErrors, ...data });
      }
    } else {
      if (data[type].findIndex((obj) => obj === id) !== -1) {
        let index = data[type].findIndex((obj) => obj === id);
        data[type].splice(index, 1);
        setEmailErrors({ ...emailErrors, ...data });
      }
    }
  };
  const changeEmail = (type, name, id) => (event) => {
    let data = { ...submissionValue };
    let index = data["email"][type].findIndex((obj) => obj.id === id);
    data["email"][type][index][name] = event.target.value;

    setSubmissionValue({ ...submissionValue, ...data });
  };

  const addEmail = (type) => {
    let data = { ...submissionValue };
    let addBody = {
      id: uuidv4(),
      address: "",
      companyName: "",
      type: type,
      status: "Y",
    };
    data.email[type].push(addBody);
    setSubmissionValue({ ...submissionValue, ...data });
  };
  const readOnlyAndDisabled = isNew || editable ? false : true;

  return (
    <Fragment>
      <Grid item xs={12}>
        <Box border={1} borderColor={"grey.500"} className={classes.boxArea}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" className={classes.headerText}>
              Assign List
            </Typography>
            <Divider className={classes.divider} />
          </Grid>
          <div className={classes.messageRecipientArea}>
            {(isNew || editable) &&
              recipientTemplate
                .filter((obj) => obj.show === true)
                .map((obj, index) => {
                  return (
                    <div key={index}>
                      <Grid item xs={12}>
                        <Legend
                          id={obj.id}
                          label={obj.label}
                          required={obj.required}
                          normalTitleColor={grayColor[10]}
                          normalBorderColor={grayColor[4]}
                          messageTitleColor={redColor[6]}
                          messageBorderColor={redColor[6]}
                          error={
                            validationErrors[obj.recipientType] &&
                            validationErrors[obj.recipientType] !== ""
                              ? true
                              : false
                          }
                          helperText={validationErrors[obj.recipientType]}
                        >
                          <div className={classes.legendArea}>
                            {submissionValue.recipients[obj.recipientType] &&
                              submissionValue.recipients[obj.recipientType].map(
                                (res, index) => {
                                  return (
                                    <Fragment key={index}>
                                      <RFIRecipientChip
                                        key={index}
                                        id={index}
                                        isNew={isNew}
                                        editable={editable}
                                        rcptType={res.rcpt_type}
                                        group_seq={res.group_seq}
                                        recipientType={obj.recipientType}
                                        rcptName={
                                          res.rcpt_type === "USER"
                                            ? res.fullname
                                            : res.rcpt_type === "USERGROUP"
                                            ? res.group_name
                                            : ""
                                        }
                                        is_attachment_readable={
                                          res.is_attachment_readable
                                        }
                                        site_user_seq={res.site_user_seq}
                                        submissionValue={submissionValue}
                                        setSubmissionValue={setSubmissionValue}
                                        removeAction={() =>
                                          removeRecipientAction(
                                            obj.recipientType,
                                            res.rcpt_type === "USERGROUP"
                                              ? res.type_seq
                                              : "",
                                            res
                                          )
                                        }
                                        handleRecipientClipClick={handleRecipientClipClick(
                                          res.group_seq
                                        )}
                                      />
                                    </Fragment>
                                  );
                                }
                              )}
                          </div>
                          <Box className={classes.addFileBtnArea}>
                            <Tooltip title={obj.title}>
                              <Fab
                                color="primary"
                                size="small"
                                aria-label="add_recipient"
                                className={classes.fileUploadBtn}
                                onClick={() => {
                                  selectRcptDialogHandleOpen(
                                    obj.dialogOpenName,
                                    obj.recipientType
                                  );
                                }}
                              >
                                <AddIcon />
                              </Fab>
                            </Tooltip>
                          </Box>
                        </Legend>
                      </Grid>
                    </div>
                  );
                })}

            {!isNew &&
              !editable &&
              recipientTemplate
                .filter((obj) => obj.showInRead === true)
                .map((obj, index) => {
                  return (
                    <div key={index}>
                      <Grid item xs={12}>
                        <Legend
                          id={obj.id}
                          label={obj.label}
                          required={obj.required}
                          normalTitleColor={grayColor[10]}
                          normalBorderColor={grayColor[4]}
                          messageTitleColor={redColor[6]}
                          messageBorderColor={redColor[6]}
                          error={
                            validationErrors[obj.recipientType] &&
                            validationErrors[obj.recipientType] !== ""
                              ? true
                              : false
                          }
                          helperText={validationErrors[obj.recipientType]}
                        >
                          {transferRcptDialogOpen && (
                            <div className={classes.legendArea}>
                              {submissionValue.recipients[obj.recipientType] &&
                                submissionValue.recipients[
                                  obj.recipientType
                                ].map((res, index) => {
                                  return (
                                    <Fragment key={index}>
                                      <RFIRecipientChip
                                        key={index}
                                        id={index}
                                        isNew={isNew}
                                        editable={editable}
                                        rcptType={res.rcpt_type}
                                        recipientType={obj.recipientType}
                                        group_seq={res.group_seq}
                                        rcptName={
                                          res.rcpt_type === "USER"
                                            ? res.fullname
                                            : res.rcpt_type === "USERGROUP"
                                            ? res.group_name
                                            : ""
                                        }
                                        is_attachment_readable={
                                          res.is_attachment_readable
                                        }
                                        submissionValue={submissionValue}
                                        setSubmissionValue={setSubmissionValue}
                                        removeAction={() =>
                                          removeRecipientAction(
                                            obj.recipientType,
                                            res.rcpt_type === "USERGROUP"
                                              ? res.type_seq
                                              : "",
                                            res
                                          )
                                        }
                                      />
                                      <Popover
                                        id={res.group_seq}
                                        open={openPopoverId === res.group_seq}
                                        anchorEl={anchorEl}
                                        onClose={handleRecipientClipClose}
                                        anchorOrigin={{
                                          vertical: "bottom",
                                          horizontal: 115,
                                        }}
                                        transformOrigin={{
                                          vertical: "top",
                                          horizontal: "center",
                                        }}
                                      >
                                        {res.rcpt_type === "USERGROUP" ? (
                                          <div className={classes.popoverMain}>
                                            {res.group_members.map((member) => {
                                              return (
                                                <div key={member.member_seq}>
                                                  <div
                                                    className={
                                                      classes.popoverMember
                                                    }
                                                  >
                                                    <PopoverMemberNameTypography>
                                                      {member.member_fullname}
                                                    </PopoverMemberNameTypography>
                                                    <PopoverCompanyNameTypography>
                                                      {
                                                        member.company
                                                          .company_name
                                                      }
                                                    </PopoverCompanyNameTypography>
                                                    {props.internalOnly &&
                                                    member.is_internal ? (
                                                      ""
                                                    ) : (
                                                      <PopoverInternalMsgTypography>
                                                        Internal Function,
                                                        External user will be
                                                        block
                                                      </PopoverInternalMsgTypography>
                                                    )}
                                                  </div>
                                                  <Divider />
                                                </div>
                                              );
                                            })}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Popover>
                                    </Fragment>
                                  );
                                })}
                            </div>
                          )}
                          {!transferRcptDialogOpen && (
                            <div className={classes.legendArea}>
                              {submissionValue.recipients[obj.recipientType] &&
                                submissionValue.recipients[
                                  obj.recipientType
                                ].map((res, index) => {
                                  return (
                                    <Fragment key={index}>
                                      <RFIRecipientChip
                                        key={index}
                                        id={index}
                                        isNew={isNew}
                                        editable={editable}
                                        recipientType={obj.recipientType}
                                        is_attachment_readable={
                                          res.is_attachment_readable
                                        }
                                        rcptType={res.rcpt_type}
                                        group_seq={res.group_seq}
                                        rcptName={
                                          res.rcpt_type === "USER"
                                            ? res.fullname
                                            : res.rcpt_type === "USERGROUP"
                                            ? res.rcpt_name
                                            : ""
                                        }
                                        handleRecipientClipClick={handleRecipientClipClick(
                                          res.group_seq
                                        )}
                                        removeAction={null}
                                      />
                                      <Popover
                                        id={res.rcpt_seq}
                                        open={openPopoverId === res.group_seq}
                                        anchorEl={anchorEl}
                                        onClose={handleRecipientClipClose}
                                        anchorOrigin={{
                                          vertical: "bottom",
                                          horizontal: 115,
                                        }}
                                        transformOrigin={{
                                          vertical: "top",
                                          horizontal: "center",
                                        }}
                                      >
                                        {res.rcpt_type === "USERGROUP" ? (
                                          <div className={classes.popoverMain}>
                                            {res.group_members.map(
                                              (member, index) => {
                                                return (
                                                  <div key={index}>
                                                    <div
                                                      className={
                                                        classes.popoverMember
                                                      }
                                                    >
                                                      <PopoverMemberNameTypography>
                                                        {member.fullname}
                                                      </PopoverMemberNameTypography>
                                                      <PopoverCompanyNameTypography>
                                                        {member.company_name}
                                                      </PopoverCompanyNameTypography>
                                                    </div>
                                                    <Divider />
                                                  </div>
                                                );
                                              }
                                            )}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Popover>
                                    </Fragment>
                                  );
                                })}
                            </div>
                          )}

                          {transferRcptDialogOpen && (
                            <Box className={classes.addFileBtnArea}>
                              <Tooltip title={obj.title}>
                                <Fab
                                  color="primary"
                                  size="small"
                                  aria-label="add_recipient"
                                  className={classes.fileUploadBtn}
                                  onClick={() => {
                                    selectRcptDialogHandleOpen(
                                      obj.dialogOpenName,
                                      obj.recipientType
                                    );
                                  }}
                                >
                                  <AddIcon />
                                </Fab>
                              </Tooltip>
                            </Box>
                          )}
                          {submissionValue.recipients[obj.recipientType]
                            .length === 0 && (
                            <div>
                              <br /> <br />
                            </div>
                          )}
                        </Legend>
                      </Grid>
                    </div>
                  );
                })}
          </div>

          {/* <Fragment>
            <div className={classes.messageRecipientArea}>
              <Legend
                label={"Email To"}
                normalTitleColor={grayColor[10]}
                normalBorderColor={grayColor[4]}
                messageTitleColor={redColor[6]}
                messageBorderColor={redColor[6]}
              >
                <Grid item xs={12}>
                  <div className={classes.legendArea}>
                    {submissionValue.email.to
                      .filter((a) => a.status === "Y")
                      .map((obj, index) => {
                        return (
                          <div key={obj.id}>
                            <Legend label={index + 1}>
                              <Grid container spacing={1}>
                                <Grid item xs={11}>
                                  <TextField
                                    className={classes.textField}
                                    fullWidth={true}
                                    id={"email_address"}
                                    name={"email_address"}
                                    label={"Email Address"}
                                    type="email"
                                    //	required={element.mandatory}
                                    size="small"
                                    variant="outlined"
                                    value={obj.address || ""}
                                    InputProps={{
                                      readOnly: readOnlyAndDisabled,
                                    }}
                                    onChange={changeEmail(
                                      "to",
                                      "address",
                                      obj.id
                                    )}
                                    onBlur={() => {
                                      checkValidMail("to", obj.address, obj.id);
                                    }}
                                    error={
                                      emailErrors["to"][
                                        emailErrors["to"].findIndex(
                                          (jobj) => jobj === obj.id
                                        )
                                      ]
                                        ? true
                                        : false
                                    }
                                    helperText={
                                      emailErrors["to"][
                                        emailErrors["to"].findIndex(
                                          (jobj) => jobj === obj.id
                                        )
                                      ]
                                        ? "Invalid Email Format"
                                        : ""
                                    }
                                  />
                                </Grid>
                                <Grid item xs={11}>
                                  <TextField
                                    className={classes.textField}
                                    fullWidth={true}
                                    id={"company_name"}
                                    name={"company_name"}
                                    label={"Company Name"}
                                    type="text"
                                    //	required={element.mandatory}
                                    size="small"
                                    variant="outlined"
                                    value={obj.companyName || ""}
                                    InputProps={{
                                      readOnly: readOnlyAndDisabled,
                                    }}
                                    onChange={changeEmail(
                                      "to",
                                      "companyName",
                                      obj.id
                                    )}
                                  />
                                </Grid>
                                {(isNew || editable) && (
                                  <Grid item xs={1}>
                                    <Tooltip title={"Delete Item"}>
                                      <DeleteIcon
                                        className={classes.viewIcon}
                                        onClick={() => {
                                          deleteConfirmAction("to", obj.id);
                                        }}
                                      />
                                    </Tooltip>
                                  </Grid>
                                )}
                              </Grid>
                            </Legend>
                          </div>
                        );
                      })}
                  </div>
                  {(isNew || editable) && (
                    <Box className={classes.addFileBtnArea}>
                      <Tooltip title={"Add Email To"}>
                        <Fab
                          color="primary"
                          size="small"
                          aria-label="add_recipient"
                          className={classes.fileUploadBtn}
                          onClick={() => {
                            addEmail("to");
                          }}
                        >
                          <AddIcon />
                        </Fab>
                      </Tooltip>
                    </Box>
                  )}
                </Grid>
              </Legend>
            </div>
            <div className={classes.messageRecipientArea}>
              <Legend
                label={"Email CC"}
                normalTitleColor={grayColor[10]}
                normalBorderColor={grayColor[4]}
                messageTitleColor={redColor[6]}
                messageBorderColor={redColor[6]}
              >
                <Grid item xs={12}>
                  <div className={classes.legendArea}>
                    {submissionValue.email.cc
                      .filter((a) => a.status === "Y")
                      .map((obj, index) => {
                        return (
                          <div key={obj.id}>
                            <Legend label={index + 1}>
                              <Grid container spacing={1}>
                                <Grid item xs={11}>
                                  <TextField
                                    required
                                    className={classes.textField}
                                    fullWidth={true}
                                    id={"email_address"}
                                    name={"email_address"}
                                    label={"Email Address"}
                                    type="text"
                                    size="small"
                                    variant="outlined"
                                    value={obj.address || ""}
                                    InputProps={{
                                      readOnly: readOnlyAndDisabled,
                                    }}
                                    onChange={changeEmail(
                                      "cc",
                                      "address",
                                      obj.id
                                    )}
                                    onBlur={() => {
                                      checkValidMail("cc", obj.address, obj.id);
                                    }}
                                    error={
                                      emailErrors["cc"][
                                        emailErrors["cc"].findIndex(
                                          (jobj) => jobj === obj.id
                                        )
                                      ]
                                        ? true
                                        : false
                                    }
                                    helperText={
                                      emailErrors["cc"][
                                        emailErrors["cc"].findIndex(
                                          (jobj) => jobj === obj.id
                                        )
                                      ]
                                        ? "Invalid Email Format"
                                        : ""
                                    }
                                  />
                                </Grid>
                                <Grid item xs={11}>
                                  <TextField
                                    className={classes.textField}
                                    fullWidth={true}
                                    id={"company_name"}
                                    name={"company_name"}
                                    label={"Company Name"}
                                    type="text"
                                    //	required={element.mandatory}
                                    size="small"
                                    variant="outlined"
                                    value={obj.companyName || ""}
                                    InputProps={{
                                      readOnly: readOnlyAndDisabled,
                                    }}
                                    onChange={changeEmail(
                                      "cc",
                                      "companyName",
                                      obj.id
                                    )}
                                  />
                                </Grid>
                                {(isNew || editable) && (
                                  <Grid item xs={1}>
                                    <Tooltip title={"Delete Item"}>
                                      <DeleteIcon
                                        className={classes.viewIcon}
                                        onClick={() => {
                                          deleteConfirmAction("cc", obj.id);
                                        }}
                                      />
                                    </Tooltip>
                                  </Grid>
                                )}
                              </Grid>
                            </Legend>
                          </div>
                        );
                      })}
                  </div>
                  {(isNew || editable) && (
                    <Box className={classes.addFileBtnArea}>
                      <Tooltip title={"Add Email CC"}>
                        <Fab
                          color="primary"
                          size="small"
                          aria-label="add_recipient"
                          className={classes.fileUploadBtn}
                          onClick={() => {
                            addEmail("cc");
                          }}
                        >
                          <AddIcon />
                        </Fab>
                      </Tooltip>
                    </Box>
                  )}
                </Grid>
              </Legend>
            </div>
          </Fragment> */}
        </Box>
      </Grid>
    </Fragment>
  );
};

export default RFIAssignList;
